/* 2026-10-04 site-health: moved verbatim from layout/theme.liquid (inline, end of body). Deferred scripts run before
   DOMContentLoaded, so this listener is registered exactly as before. */
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery) return;
    $(function() {
        const showMoreLessButton = $('#show_more_less');
          const extraContent = $('.extra_content');
        
          showMoreLessButton.on('click', function () {
            if ($(this).hasClass('hide1')) {
              extraContent.slideDown(800);
              $(this).removeClass('hide1').addClass('show1').text('show less');
            } else {
              extraContent.slideUp(800);
              $(this).removeClass('show1').addClass('hide1').text('show more');
            }
          });

        $('.readmore').click(function(){
           
          $('.des_short').hide();
          $('.des_full').slideDown(800);
          //$(this).removeClass('readmore').addClass('readless');
          //$(this).text('Read Lesssss');
        });

        $('.readless').click(function(){
           //$('.des_full').hide();
         $('.des_full').slideUp(800);
           setTimeout(function () {
            $('.des_short').show();
             
            // $(this).text('Read Moreeee');
           }, 850);
          //$(this).removeClass('readless').addClass('readmore');
          
        });

        $('.collection-banner-read-more').click(function(){    
            if($('#full-description').is(":visible")){
                $('#full-description').slideUp(2000);
                $('#short-description').css('display','block');
                $(this).text("Read More");
            }else{
                $('#short-description').css('display','none');
                $('#full-description').slideDown(2000);
                $(this).text("Read Less");
            }
        });
        
       });
       

    jQuery(function ($) {
        let box = $('#full-description');
        let btn = $('#desc-toggle');
        if (!box.length) { return; }   // guard: element only exists on collection pages
        let collapsedHeight = 180;
        let fullHeight = box[0].scrollHeight;

        if (fullHeight <= collapsedHeight) {
            btn.hide();
        }
        btn.on("click", function () {
            if (box.hasClass("expanded")) {
                // Collapse
                box.removeClass("expanded").css("height", collapsedHeight + "px");
                btn.text("Read More");
            } else {
                // Expand
                box.addClass("expanded").css("height", fullHeight + "px");
                btn.text("Read Less");
            }
        });
    });

  });
